import './publish_notification.ui.less';

import React, { Component } from 'react';

class PublishNotificationUI extends Component {

  render() {
    const { title, children } = this.props;

    return (
      <div className="publish-notification">
        <div className="notif-body">

          <div className="share-content">
            <div className="success-container">
              Success!
            </div>

            <div className="title-container">
              {title}
            </div>

            <div className="subtitle-container">
              { children }
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default PublishNotificationUI;
